import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import { Search, FileText, Users, Building2 } from 'lucide-react';
import {setExchangeType} from "../../../store/slices/exchange.slice";

const ActionCard = ({ icon: Icon, title, description, onClick }) => (
  <div className="p-6 bg-white round-1 bordered hover:border-gray-200 transition-all duration-200 cursor-pointer group"
       onClick={onClick}
  >
    <div className="flex flex-col items-start gap-4">
      <div className="p-3 rounded-full bg-gradient-to-b from-slate-900 to-gray-950 transition-colors duration-200">
        <Icon className="w-4 h-4 text-slate-300" />
      </div>
      <div>
        <h3 className="text-sm upper text-gray-900 mb-1">{title}</h3>
        <p className="text-xs text-gray-500">{description}</p>
      </div>
    </div>
  </div>
);

const CompanyActionGrid = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

    const handleNavigateToExchange = useCallback(() => { // Make this callback stable
        dispatch(setExchangeType('company'));
        navigate('/portfolios/exchange');
    }, [dispatch, navigate]);

    const handleNavigateToPathPages = useCallback(() => {
        navigate('/company/paths/pages');
    }, [navigate]);

  const actions = [
    {
      icon: Search,
      title: "Find Portfolios",
      description: "Search and discover portfolios available on the exchange",
      onClick: handleNavigateToExchange
    },
    {
      icon: FileText,
      title: "Portfolio Grid",
      description: "Select portfolios to add to a new or existing path grid",
      onClick: handleNavigateToPathPages
    },
    {
      icon: Users,
      title: "Invite Users",
      description: "Add team members and manage permissions"
    },
    {
      icon: Building2,
      title: "Manage Company",
      description: "Update company settings and preferences",
      onClick: () => navigate('/company/details/edit')
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
      {actions.map((action, index) => (
        <ActionCard key={index} {...action} />
      ))}
    </div>
  );
};

export default CompanyActionGrid;